export default __webpack_public_path__ + "static/media/002-lifesaver.c44e31e3.png";